import React from "react";
import { Card, Typography } from "@mui/material";
import styles from "./aiContextualizationReport.module.scss";

const StatCard = ({ icon, title, value, meta, progress, delta, status }) => {
  const Icon = icon;
  return (
    <Card className={styles.statCard}>
      <div className={styles.statHeader}>
        <span className={styles.statIcon}>
          {Icon ? <Icon size={18} /> : null}
        </span>
        <Typography className={styles.statTitle}>{title}</Typography>
      </div>
      <div className={styles.statValueRow}>
        <Typography className={styles.statValue} fontWeight={800}>
          {value}
        </Typography>
        {delta ? <span className={styles.statDelta}>{delta}</span> : null}
      </div>
      <div className={styles.statMetaRow}>
        <span className={styles.statMeta}>{meta}</span>
        {status ? <span className={styles.statStatus}>{status}</span> : null}
      </div>
      {typeof progress === "number" ? (
        <div className={styles.statProgress}>
          <span style={{ width: `${progress}%` }} />
        </div>
      ) : null}
    </Card>
  );
};

export default StatCard;
